import { axios } from '@/plugins/http-axios';
import { Module } from 'vuex';
import { useEnvStore } from '@/pinia/general/env';
import { pinia } from '@/main';

interface IDataEnv {
  [key: string]: string;
}
interface IEnvState {
  env: IDataEnv;
}
export default <Module<IEnvState, any>>{
  state: {
    env: {},
  },
  mutations: {
    setEnv(state, data: IDataEnv) {
      state.env = data;
    },
  },
  actions: {
    getEnv({ commit, dispatch, getters, rootGetters }): Promise<void> {
      if (getters.isEnv) return Promise.resolve();

      const envStore = useEnvStore(pinia);
      return axios
        .get<IDataEnv>(rootGetters.uri.env)
        .then((resp) => {
          commit('setEnv', resp.data);
          envStore.setEnv(resp.data);
        })
        .catch((e) => {
          e.uri = rootGetters.uri.env;
          dispatch('setError', e);
          return Promise.reject(e);
        });
    },
  },
  getters: {
    isEnv: (state): boolean => !!Object.keys(state.env).length,
    env: (state): IDataEnv => state.env,
    flag:
      (state) =>
      (code: string): boolean | undefined => {
        const flag = Object.keys(state.env).find((key) => key === code);

        //@ts-ignore
        return flag ? state.env[code] : undefined;
      },
    isDarkTheme: (state, getters): boolean => getters.flag('DARK_THEME_ACTIVATE'),
    isHideOffice: (state, getters): boolean => getters.flag('HIDE_OFFICE'),
    isConveyorIndividuals: (state, getters): boolean => getters.flag('CONVEYOR_INDIVIDUALS'),
    isNewQuestionnaireMode: (state, getters): boolean => getters.flag('IS_NEW_QUESTIONNAIRE_MODE'),
    isCryptoproEnableLkk: (state, getters): boolean => getters.flag('CRYPTOPRO_ENABLE_LKK'),
    isCheckInnCertificateAndMchd: (state, getters): boolean => getters.flag('CHECK_INN_CERTIFICATE_AND_MCHD'),
    isWorkingWithNonResidents: (state, getters): boolean => getters.flag('WORKING_WITH_NON_RESIDENTS'),
    isShowOrgStatusEnabled: (state, getters): boolean => getters.flag('SHOW_ORG_STATUS_ENABLED'),
    showOrgStatus: (state, getters): string[] => getters.isShowOrgStatusEnabled ? getters.flag('SHOW_ORG_STATUS') : [],
  },
};
